import { useState } from 'react'

import {
  ConsentPreferencesProvider,
  type ConsentPreferencesProviderProps,
} from '../react/collect'
import { CookieConsentBanner } from './banner'
import { CookieConsentDialog } from './dialog'

export type CookieConsentUIProps = ConsentPreferencesProviderProps

export function CookieConsentUI({
  children,
  ...providerProps
}: CookieConsentUIProps) {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <ConsentPreferencesProvider {...providerProps}>
      {children}
      <CookieConsentBanner onCustomise={() => setDialogOpen(true)} />
      <CookieConsentDialog
        open={dialogOpen}
        onDismiss={() => setDialogOpen(false)}
      />
    </ConsentPreferencesProvider>
  )
}
